import React, { useMemo, useState } from "react";
import { Search, X, ChevronRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { searchSettings } from "@/lib/settingsSearch";

// Défile jusqu'au réglage choisi (une fois sa section affichée) et le met en évidence 1,6 s.
export const revealSettingsItem = (testId, tries = 0) => {
  const el = document.querySelector(`[data-testid="${testId}"]`);
  if (!el) { if (tries < 8) setTimeout(() => revealSettingsItem(testId, tries + 1), 120); return; }
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.classList.remove("yalola-flash");
  void el.offsetWidth;
  el.classList.add("yalola-flash");
  setTimeout(() => el.classList.remove("yalola-flash"), 1700);
};

// Barre de recherche des Paramètres : tape un mot → liste des réglages (libellé + section) → clic = ouvre la section et défile.
export const SettingsSearch = ({ t, sections, onPick, hasThanks }) => {
  const [q, setQ] = useState("");
  const titles = useMemo(() => Object.fromEntries(sections.map((s) => [s.key, t(...s.title)])), [sections, t]);
  const results = useMemo(() => searchSettings(q, t, titles, { hasThanks }), [q, t, titles, hasThanks]);
  const active = q.trim().length > 0;
  const pick = (it) => { setQ(""); onPick(it); };
  return (
    <div className="space-y-2" data-testid="settings-search">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: "var(--yalola-text-muted)" }} />
        <Input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && results[0]) pick(results[0]); if (e.key === "Escape") setQ(""); }}
          placeholder={t("settings.search_placeholder", "Rechercher un réglage (mot de passe, langue, cartes…)")}
          className="pl-9 pr-9 h-11 rounded-full"
          aria-label={t("settings.search_placeholder", "Rechercher un réglage (mot de passe, langue, cartes…)")}
          data-testid="settings-search-input"
        />
        {active && (
          <button type="button" onClick={() => setQ("")} className="absolute right-2 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full grid place-items-center" style={{ color: "var(--yalola-text-muted)" }} aria-label={t("common.clear", "Effacer")} data-testid="settings-search-clear">
            <X size={15} />
          </button>
        )}
      </div>
      {active && (
        <div className="yalola-card overflow-hidden" data-testid="settings-search-results" data-count={results.length}>
          {results.length === 0 ? (
            <p className="px-4 py-3 text-sm" style={{ color: "var(--yalola-text-muted)" }} data-testid="settings-search-empty">
              {t("settings.search_none", "Aucun réglage ne correspond à « {q} ».").replace("{q}", q.trim())}
            </p>
          ) : (
            <ul className="divide-y" style={{ borderColor: "var(--yalola-border)" }}>
              {results.map((it) => {
                const sec = sections.find((s) => s.key === it.section);
                return (
                  <li key={it.id}>
                    <button type="button" onClick={() => pick(it)} className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-[var(--yalola-surface-alt)] transition-colors" data-testid={`settings-search-result-${it.id}`}>
                      {sec && <div className="h-8 w-8 rounded-lg grid place-items-center shrink-0" style={{ background: "var(--yalola-primary-soft)", color: "var(--yalola-primary)" }}><sec.icon size={16} /></div>}
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium truncate">{it.text}</div>
                        <div className="text-[11px]" style={{ color: "var(--yalola-text-muted)" }}>{it.sectionTitle}</div>
                      </div>
                      <ChevronRight size={16} style={{ color: "var(--yalola-text-muted)" }} />
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
